<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
            <v-layout column >
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                  >
                    <template v-slot:body>
                      <v-row>
                        <v-col cols="auto" align="center" class="pa-2 pt-3">
                          <v-icon small color="blue">mdi-circle</v-icon>
                          <span class="subMessege"> Quotation No </span>
                        </v-col>
                        <v-col cols="2" class="pa-2">
                          <v-select
                            v-model="quotNo"
                            :items="quotNoList"
                            item-value="sysCode"
                            label="Select No"
                            return-object
                            single-line
                            clearable
                            outlined
                            dense
                          ></v-select>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" class="pa-0">
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.quotNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Title</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.shipNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Ship No, POR No</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.QuotationNo" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Start Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.supplier" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Finish Time</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.amount" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Delivery Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Payment Condition</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.fax" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Purchase Charger</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.transFee" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Recieve Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Submit Date</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.fax" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader">
                      <span>Quotation Amount</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.transFee" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader3">
                      <span>Remark</span>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field 
                        v-model="formData.charger" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable 
                        readonly
                      />
                    </v-col>
                    <v-col cols="1" align="right" class="pr-2 pt-1 formHeader3">
                      <span>Money Unit</span>
                    </v-col>
                    <v-col cols="3">
                      <v-text-field 
                        v-model="formData.fax" 
                        dense 
                        outlined 
                        hide-details="auto"
                        clearable
                        readonly
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms4030" 
                    class="hipGridHeight5" 
                    :ref="epms4030Ref"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    @cellPrepared="cellPrepared"
                  >
                    <DxEditing :use-icons="true" />
                    <DxColumn data-field="" caption="No" width="3%" data-type="string" alignment="center" :visible="true" />
                    <DxColumn data-field="" caption="Ship No" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="POR No" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxColumn data-field="" caption="Block" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="Part No" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxColumn data-field="" caption="P. Qty" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="Material Specification" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxColumn data-field="" caption="Unit Wgt" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="Material Specification" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxColumn data-field="" caption="TotalWgt" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="Material Specification" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxColumn data-field="" caption="Production Fee" width="10%" data-type="string" alignment="center" >
                      <DxColumn data-field="" caption="Material" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Prod." width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Gal." width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Paint" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="SP" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Treatment" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Sub.Total" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Others" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="ACC" width="10%" data-type="string" alignment="center" />
                      <DxColumn data-field="" caption="Total" width="10%" data-type="string" alignment="center" />
                    </DxColumn>
                    <DxPaging :enabled="true" :page-size="30" />
                  </DxDataGrid>
                  <!-- <div :style="bottomText">
                    <v-icon color="blue">$folder</v-icon><span class="pl-1" style="fontSize: 10pt; color: black;">View Drawing Page</span>
                  </div> -->
                </v-col>
              </v-row>
            </v-layout>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import notify from 'devextreme/ui/notify' // message
import { getRequestHead } from '@/api/view/hip/4/epms4050.js'

export default {
  name: 'epms4050',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing,
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      formData: {
        quotNo: '', quotStep: '', makerCd: '', quotTitle: '', matlDiv: '', shipPorNo: '', startDte: '', finishDte: '', transCond: '', payCond: '',  wonRate: '',
        usdRate: '', rateRate: '', transCondDesc: '', payCondDesc: '', buyerName: '', receiveYn: '', submitYn: '', printYn: '', receiveDte: '', submitDte: '', printDte: '',
        piAmount: '', moneUnit: '', remark: '',
      },

      epms4030Ref: 'epms4030Ref',
      gridMainList: [],
      
      //cell merge
      mergeElements: [],
      mergeStartElements: [],

      mergeElements2: [],
      mergeStartElements2: [],

      bottomText: 'display:none;',

      quotNoList: [],
      quotationNo: '',
      quotNo: ''

    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms4030Ref)
    },
  },
  mounted() {
    this.doSearchMain()
  },
  methods: {
    async doSearchMain(){
      this.openLoading('searching')
      let params = {
        makerCd: this.$store.state.user.makerCd,
        quotNo: this.quotNo,
      }
      await getRequestHead(params).then(res => {
        if(res.list.length){
          let list = res.list[0]
          this.formData = {
            poNo: list.poNo , shipNo: list.shipNm, QuotationNo: list.quotNo, supplier:list.custNm, amount: getNumComma(list.poAmt), 
            charger:list.buyerNm, fax: list.custFax, transFee: list.transFee ,transport: list.transCondDesc, 
            payment: list.payCondDesc, govFee: list.govFee, total: getNumComma(list.totAmt) + ' ' + list.moneUnit ,request: list.reqDept
          }
        }
      }).finally(() => {
        this.endLoading()
      })

    },
    cellPrepared(e){
      if(e.rowType === 'data'){
        // console.log(" >>> " , e)
        this.merge('no', this.mergeElements, this.mergeStartElements, e)
      } else {
        this.merge2(e)
      }
    },
    merge(filed, mergeEle, mergeEleStart, e){
      if (e.column.dataField === filed || e.column.dataField === 'materialCode' || e.column.dataField === 'materialSpec' || e.column.dataField === 'deliveryDate'
          || e.column.dataField === 'cert' ) {
        e.cellElement.style['vertical-align'] = 'middle'
        if (this.curRowIndex + 1 !== this.gridMainList.length) {
          if (e.rowIndex > 0) {
            // If the value of the previous row and the current value match, and the value of no is also the same
            if (e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value && e.column.dataField === filed ) {
              if (e.component.cellValue(e.rowIndex - 1, e.column.dataField)) {
                // when value is not blank
                var prev = mergeEle[e.rowIndex - 1]
                if (!mergeEle[e.rowIndex]) {
                  mergeEle[e.rowIndex] = {}
                }
                mergeEle[e.rowIndex] = prev
                mergeEleStart[e.rowIndex] = prev
                if (prev) {
                  let curCellElement = e.cellElement
                  curCellElement.style.display = 'none'

                  var span = prev.getAttribute('rowspan')
                  if (span) {
                    prev.setAttribute('rowspan', Number(span) + 1)
                  } else {
                    prev.setAttribute('rowspan', 2)
                  }
                  this.nonDispalyedRowIndex.push(e.rowIndex)
                }
              } else {
                // when value is blank
                if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
                mergeEle[e.rowIndex] = e.cellElement
              }
            } else {
              // If the value of the previous row is different from the current value
              if (!mergeEle[e.rowIndex]) mergeEle[e.rowIndex] = {}
              mergeEle[e.rowIndex] = e.cellElement
            }
          } else {
            // When index is 0
            if (!mergeEle[e.rowIndex]) {
              mergeEle[e.rowIndex] = {}
            }
            mergeEle[e.rowIndex] = e.cellElement
          }
          this.curRowIndex = e.rowIndex
        } else {
          // When everything is running and clicked
          if (this.nonDispalyedRowIndex.indexOf(e.rowIndex) !== -1) {
            e.cellElement.style.display = 'none'
          } else {
            if (typeof mergeEleStart[e.rowIndex + 1] === 'undefined') return
            let rowspan = mergeEleStart[e.rowIndex + 1].getAttribute('rowspan')
            e.cellElement.setAttribute('rowspan', rowspan)
          }
        }
        // To remove duplication of nonDispalyedRowIndex
        const set = new Set(this.nonDispalyedRowIndex)
        this.nonDispalyedRowIndex = [...set]
      }
    },
    merge2(e){
      if(e.column.caption === 'Material Specification'){
        if(e.columnIndex == '2'){
          // console.log(" >>> " , e)
          e.cellElement.setAttribute('colspan' , 3)
        }else {
          e.cellElement.style.display = 'none'
        }
      }
      e.cellElement.style['vertical-align'] = 'middle'
    },
    btnRetrieve(){

    },
    btnPorSheet(){

    },
    btnBomList(){

    },
    btnSuccessList(){

    },
  }
}
</script>
<style scoped>
.formHeader {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  border-bottom: 0px;
  color: black;
  font-size: 9pt;
}
.formHeader2 {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  border-top: 0px;
  color: black;
  font-size: 9pt;
}
.formHeader3 {
  background-color: rgb(223, 227, 213);
  font-weight: bold;
  border: 1px solid gray;
  color: black;
  font-size: 9pt;
}
.subMessege {
  color: black;
  font-weight: bold;
}
</style>